import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
 
import playstore from "../assets/playstore.png";
import appstore from "../assets/appstore.png";
// import phone1 from "../assets/hero-img.png";
import phone2 from "../assets/HeroImages.png";

const HeroSection = () => {
  return (
    <div className="hero-section">
      {/* TEXT SECTION - FULL SCREEN */}
      <div className="hero-text-section">
        <Container>
          <Row className="justify-content-center h-100">
            <Col xs={12} className="text-center d-flex flex-column justify-content-center h-100">
              {/* Hero Title */}
              <motion.h1
                className="hero-title mx-auto"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.2 }}
              >
                Your Tax Deduction Assistant!
              </motion.h1>

              {/* Hero Description */}
              <motion.p
                className="hero-description mx-auto"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.4 }}
              >
               Don't miss another potential Tax deduction! WriteOffGenie helps turn everyday business expenses into legitimate tax deductions 
               — with audit-ready documentation.
              </motion.p>

              {/* Store Buttons */}
              <motion.div
                className="store-buttons d-flex  align-items-center justify-content-center "
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.6 }}
              >
                <motion.a
                  href="https://play.google.com/store/apps/details?id=com.writeoffgenie.app&pcampaignid=web_share"
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  style={{ cursor: "pointer", display: "inline-block" }}
                >
                  <img 
                    src={playstore} 
                    alt="Get it on Google Play" 
                    className="store-img"
                    style={{
                      width: "160px",
                      height: "auto",
                      borderRadius: "10px"
                    }}
                  />
                </motion.a>

                <motion.a
                  href="https://apps.apple.com/us/app/writeoffgenie/id6751060559"
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  style={{ cursor: "pointer", display: "inline-block" }}
                >
                  <img 
                    src={appstore} 
                    alt="Download on the App Store" 
                    className="store-img"
                    style={{
                      width: "160px",
                      height: "auto",
                      borderRadius: "10px"
                    }}
                  />
                </motion.a>
              </motion.div>

              <motion.p
                className="text-dark text-center fw-bold mt-3"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1, delay: 0.8 }}
              >
                Secure • IRS-Ready
              </motion.p>
            </Col>
          </Row>
        </Container>
      </div>

      {/* PHONE IMAGES SECTION - FULL SCREEN */}
      <div className="hero-image-section">
        <Container className="h-100">
          <Row className="justify-content-center h-100">
            <Col xs={12} className="justify-content-center align-items-center h-100">
              <motion.div 
                className="phone-display"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1.2, delay: 1 }}
              >
                <img
                  src={phone2}
                  alt="WriteOffGenie App"
                  className="hero-phone-img"
                />
              </motion.div>

              <p className="container text-center mt-4 mb-0 pb-0">
                Your ultimate tax companion for 1099 contractors and small business owners — Helping you find, track, and claim every possible deduction. On average, users save over $20,000 a year by uncovering missed write-offs and staying tax-ready all year long
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default HeroSection;
